export const isAllowedImageType = (imageType) => {
  const typeRegex = /image\/(jpg|jpeg|png)$/
  return typeRegex.test(imageType)
}

export const isAllowedReceiptMimeType = (mimeType) => {
  const typeRegex = /(application\/pdf)|(image\/(jpg|jpeg|png))$/
  return typeRegex.test(mimeType)
}
